export const works = [
  {
    id: "night-tokyo", title: "夜色东京", category: "drama", region: "日本", year: 2025, cover: "nightAlley",
    rating: 9.2, views: 482300, episodeCount: 12, director: "高桥凉", studio: "夜色制作", duration: "26 分钟 / 集",
    tags: ["都市夜行", "情绪叙事", "雨夜"],
    synopsis: "深夜的东京街头，一名纪录片导演遇见只在雨夜出现的女子。两人以七天为期限，交换彼此不敢说出口的过去，也把这座城市最暗的一面照亮。",
  },
  {
    id: "confession-after-rain", title: "雨后的告白", category: "drama", region: "日本", year: 2024, cover: "rainGlass",
    rating: 8.7, views: 311200, episodeCount: 9, director: "小林透", studio: "白川工作室", duration: "24 分钟 / 集",
    tags: ["雨季", "初恋", "慢节奏"],
    synopsis: "一场持续整月的梅雨，让两个原本只是邻居的人开始共享同一把伞。当雨停下来的那天，他们必须决定，这段关系是否也要跟着放晴。",
  },
  {
    id: "neon-never-sleeps", title: "霓虹未眠", category: "drama", region: "中国香港", year: 2026, cover: "tokyoSkyline",
    rating: 9.4, views: 526800, episodeCount: 14, director: "陈立行", studio: "蓝调映像", duration: "28 分钟 / 集",
    tags: ["城市夜景", "群像", "黄金年代"],
    synopsis: "八十年代霓虹灯牌即将被拆除的前一个月，三个在旧街区讨生活的人，用各自的方式和这片灯火做最后的告别。",
  },
  {
    id: "letters-from-south", title: "南方来信", category: "drama", region: "泰国", year: 2025, cover: "moonBeach",
    rating: 8.5, views: 188400, episodeCount: 8, director: "颂猜", studio: "曼谷九号", duration: "25 分钟 / 集",
    tags: ["海岛", "书信", "慢生活"],
    synopsis: "曼谷女孩接手祖母留下的海边旧旅馆，在阁楼发现一叠从未寄出的信。收信人的名字，恰好是镇上那个沉默的潜水教练。",
  },
  {
    id: "after-spring-equinox", title: "春分之后", category: "drama", region: "韩国", year: 2024, cover: "windowShadow",
    rating: 8.9, views: 264700, episodeCount: 10, director: "朴承宇", studio: "首尔光映", duration: "27 分钟 / 集",
    tags: ["季节限定", "重逢", "细腻"],
    synopsis: "春分那天，一对分开五年的恋人在旧公寓楼下重新遇见。他们约定只用一天时间，把所有没说完的话说完，然后各自回到自己的生活。",
  },
  {
    id: "silent-cinema", title: "无声电影院", category: "drama", region: "日本", year: 2023, cover: "crimsonCurtain",
    rating: 9.0, views: 219500, episodeCount: 11, director: "高桥凉", studio: "夜色制作", duration: "23 分钟 / 集",
    tags: ["老影院", "默片", "怀旧"],
    synopsis: "一间即将停业的单厅影院，放映员与常客女孩用字幕卡代替对话，在最后一卷胶片放完之前，讲述各自人生里最安静的一段故事。",
  },
  {
    id: "room-by-the-sea", title: "海边的房间", category: "drama", region: "中国台湾", year: 2025, cover: "hotelSuite",
    rating: 8.6, views: 173900, episodeCount: 9, director: "王翊", studio: "白川工作室", duration: "25 分钟 / 集",
    tags: ["民宿", "夏日", "疗愈"],
    synopsis: "台北的上班族请了一个月长假，回到东部老家整理外婆的民宿。她没想到，第一位入住的客人，是当年不告而别的那个人。",
  },
  {
    id: "late-night-diner", title: "深夜餐馆的客人", category: "drama", region: "日本", year: 2024, cover: "retroBar",
    rating: 8.8, views: 298100, episodeCount: 12, director: "小林透", studio: "白川工作室", duration: "22 分钟 / 集",
    tags: ["单元故事", "美食", "深夜"],
    synopsis: "凌晨一点开门的小餐馆，只做一道菜。每一位走进来的客人，都带着一个不愿在白天提起的故事，而老板只负责把菜做好。",
  },
  {
    id: "she-in-backlight", title: "逆光里的她", category: "drama", region: "韩国", year: 2026, cover: "goldLight",
    rating: 9.1, views: 341600, episodeCount: 13, director: "李书妍", studio: "首尔光映", duration: "27 分钟 / 集",
    tags: ["摄影", "缪斯", "光影"],
    synopsis: "一名陷入创作瓶颈的摄影师，在清晨的公交站遇见一个总站在逆光里的女人。为了留住那道轮廓，他开始重新学习如何观看一个人。",
  },
  {
    id: "december-train", title: "十二月的列车", category: "drama", region: "日本", year: 2025, cover: "nightTrain",
    rating: 8.9, views: 205800, episodeCount: 10, director: "高桥凉", studio: "夜色制作", duration: "24 分钟 / 集",
    tags: ["旅途", "冬夜", "错过"],
    synopsis: "年末的最后一班夜行列车，六节车厢里坐着六个各自逃离的人。天亮之前，他们必须在天亮之后各自下车，谁也不能留下联系方式。",
  },
  {
    id: "neighbor-sister-secret", title: "邻家姐姐的秘密", category: "ethic", region: "日本", year: 2024, cover: "hotelSuite",
    rating: 8.8, views: 412700, episodeCount: 10, director: "小林透", studio: "白川工作室", duration: "26 分钟 / 集",
    tags: ["邻里", "日常", "秘密"],
    synopsis: "大学新生搬到旧公寓的第一天，就发现隔壁那位总是笑着打招呼的姐姐，夜里会准时收到同一个人的电话，然后一个人坐到天亮。",
  },
  {
    id: "seventh-day-of-marriage", title: "婚后的第七天", category: "ethic", region: "韩国", year: 2025, cover: "windowShadow",
    rating: 9.0, views: 384500, episodeCount: 12, director: "朴承宇", studio: "首尔光映", duration: "28 分钟 / 集",
    tags: ["婚姻", "日常裂缝", "心理"],
    synopsis: "新婚第七天，丈夫在行李箱夹层里发现一封写给别人的信。为了不让这场婚姻在开始时就结束，他们决定用一个星期把一切摊开来讲。",
  },
  {
    id: "sisters-room", title: "姐姐的房间", category: "ethic", region: "中国台湾", year: 2023, cover: "vintageMirror",
    rating: 8.4, views: 156300, episodeCount: 8, director: "王翊", studio: "蓝调映像", duration: "25 分钟 / 集",
    tags: ["家族", "旧宅", "回忆"],
    synopsis: "姐姐出国那年，把房间钥匙交给妹妹保管。十年后妹妹准备结婚，回到那间从没被打开过的房间，才发现姐姐留下的是另一种告别。",
  },
  {
    id: "exchanged-lives", title: "交换人生", category: "ethic", region: "日本", year: 2026, cover: "smokeGold",
    rating: 9.3, views: 445900, episodeCount: 14, director: "高桥凉", studio: "夜色制作", duration: "29 分钟 / 集",
    tags: ["双线叙事", "身份", "伦理"],
    synopsis: "两个长得一模一样的女人在车站偶遇，一时兴起交换了三天身份。三天结束时，其中一个人已经不想回去了。",
  },
  {
    id: "family-portrait", title: "家族写真", category: "ethic", region: "韩国", year: 2024, cover: "marbleStairs",
    rating: 8.9, views: 233700, episodeCount: 11, director: "李书妍", studio: "首尔光映", duration: "26 分钟 / 集",
    tags: ["家族聚会", "隐秘关系", "群像"],
    synopsis: "父亲七十大寿，散居各地的子女回到老宅拍全家福。摄影师按下快门的瞬间，有人缺席，有人多带了一个不该出现的人。",
  },
  {
    id: "stepmother-diary", title: "继母的日记", category: "ethic", region: "日本", year: 2025, cover: "blackLace",
    rating: 8.6, views: 302400, episodeCount: 10, director: "白川遥", studio: "白川工作室", duration: "27 分钟 / 集",
    tags: ["家庭关系", "日记体", "克制"],
    synopsis: "父亲再婚后，女儿在整理书房时翻到继母的日记。日记里记的不是怨言，而是二十年来她如何小心翼翼地不打扰这个家。",
  },
  {
    id: "double-bed", title: "双人床", category: "ethic", region: "中国香港", year: 2024, cover: "silkDrape",
    rating: 8.7, views: 271500, episodeCount: 9, director: "陈立行", studio: "蓝调映像", duration: "25 分钟 / 集",
    tags: ["同居", "冷战", "都市"],
    synopsis: "一对准备分手的伴侣，因为房租太贵继续同住。他们用胶带在双人床中间划了一条线，也划出了这段关系最后的边界。",
  },
  {
    id: "afternoon-of-married-woman", title: "已婚女人的午后", category: "ethic", region: "韩国", year: 2026, cover: "windowShadow",
    rating: 9.1, views: 358200, episodeCount: 12, director: "朴承宇", studio: "首尔光映", duration: "28 分钟 / 集",
    tags: ["午后", "自我觉醒", "细腻"],
    synopsis: "结婚第八年，她把孩子送去学校后的两个小时，成了唯一属于自己的时间。直到某个午后，有人按响了门铃，带来一个她从未想过的选择。",
  },
  {
    id: "sisters-secret", title: "妹妹的秘密", category: "ethic", region: "泰国", year: 2025, cover: "moonGarden",
    rating: 8.5, views: 149800, episodeCount: 8, director: "颂猜", studio: "曼谷九号", duration: "24 分钟 / 集",
    tags: ["姐妹", "乡下", "夏夜"],
    synopsis: "姐姐从城市回到乡下老家，发现妹妹每晚都会出门，直到天亮才回来。她决定跟上去，结果看见的是妹妹独自守护的另一个家。",
  },
  {
    id: "under-the-eaves", title: "屋檐之下", category: "ethic", region: "日本", year: 2023, cover: "rainGlass",
    rating: 8.8, views: 198600, episodeCount: 11, director: "小林透", studio: "白川工作室", duration: "26 分钟 / 集",
    tags: ["旧屋", "雨水", "家族"],
    synopsis: "老屋漏雨的那个夏天，分居多年的兄弟不得不一起回来修屋顶。锤子敲了三天，他们才终于说起父亲葬礼上没说完的那句话。",
  },
  {
    id: "city-night-walker", title: "都市夜归人", category: "urban", region: "中国香港", year: 2025, cover: "retroBar",
    rating: 9.0, views: 396400, episodeCount: 12, director: "陈立行", studio: "蓝调映像", duration: "27 分钟 / 集",
    tags: ["夜生活", "酒吧", "群像"],
    synopsis: "凌晨两点的兰桂坊，酒保见过太多不肯回家的人。这一季，他决定为每位独坐的客人调一杯只属于他们的酒。",
  },
  {
    id: "overtime-until-three", title: "加班到凌晨三点", category: "urban", region: "日本", year: 2026, cover: "officeNight",
    rating: 8.9, views: 334900, episodeCount: 13, director: "高桥凉", studio: "夜色制作", duration: "26 分钟 / 集",
    tags: ["办公室", "社畜", "暧昧"],
    synopsis: "项目截止前的每个深夜，整层楼只剩下两个人。他们从讨论方案，聊到人生，再聊到为什么还不下班，最后连灯都忘了关。",
  },
  {
    id: "seoul-midnight-bus", title: "首尔午夜巴士", category: "urban", region: "韩国", year: 2024, cover: "seoulStreet",
    rating: 8.8, views: 241700, episodeCount: 10, director: "李书妍", studio: "首尔光映", duration: "25 分钟 / 集",
    tags: ["夜班车", "擦肩", "城市"],
    synopsis: "末班巴士每天凌晨零点十分经过汉江大桥。司机记得每一个固定乘客，也知道他们都在同一个站下车，却从没有人一起走过那段路。",
  },
  {
    id: "roommate", title: "合租室友", category: "urban", region: "泰国", year: 2025, cover: "hotelSuite",
    rating: 8.6, views: 187300, episodeCount: 11, director: "颂猜", studio: "曼谷九号", duration: "25 分钟 / 集",
    tags: ["合租", "生活流", "轻喜"],
    synopsis: "为了分摊房租，两个生活习惯完全相反的人住进了同一间公寓。冰箱上的便条从抱怨，慢慢变成了留给对方的一日三餐。",
  },
  {
    id: "seventh-floor-office", title: "办公室的第七层", category: "urban", region: "韩国", year: 2026, cover: "officeNight",
    rating: 9.2, views: 368700, episodeCount: 12, director: "朴承宇", studio: "首尔光映", duration: "28 分钟 / 集",
    tags: ["职场", "秘密", "权力"],
    synopsis: "公司第七层从不上锁，却没人愿意加班到那一层。新来的实习生误闯之后，才发现整层楼只为一个人保留着灯。",
  },
  {
    id: "convenience-night-shift", title: "便利店夜班", category: "urban", region: "日本", year: 2024, cover: "retroBar",
    rating: 8.7, views: 213600, episodeCount: 10, director: "白川遥", studio: "白川工作室", duration: "23 分钟 / 集",
    tags: ["便利店", "夜班", "小人物"],
    synopsis: "深夜便利店的收银台前，每个客人都有一段不想被看见的生活。夜班店员唯一能做的，是把关东煮的汤加热一点。",
  },
  {
    id: "thirty-seconds-in-elevator", title: "电梯里的三十秒", category: "urban", region: "中国台湾", year: 2025, cover: "marbleStairs",
    rating: 8.9, views: 176900, episodeCount: 9, director: "王翊", studio: "蓝调映像", duration: "22 分钟 / 集",
    tags: ["公寓", "擦出火花", "单元"],
    synopsis: "同一栋公寓的电梯，每天固定故障三十秒。三十秒里，两个从不打招呼的人开始说话，也从三十秒开始，期待下一次故障。",
  },
  {
    id: "perfume-and-smoke", title: "香水与烟", category: "urban", region: "中国香港", year: 2023, cover: "smokeGold",
    rating: 9.0, views: 287500, episodeCount: 11, director: "陈立行", studio: "蓝调映像", duration: "27 分钟 / 集",
    tags: ["香氛", "旧情", "夜香港"],
    synopsis: "调香师为一位神秘客人定制香水，对方只提出一个要求：要像某个人的味道。当配方完成，她才认出那是自己丢失多年的记忆。",
  },
  {
    id: "wind-on-the-roof", title: "天台上的风", category: "urban", region: "日本", year: 2026, cover: "rooftopDusk",
    rating: 8.8, views: 159400, episodeCount: 10, director: "高桥凉", studio: "夜色制作", duration: "24 分钟 / 集",
    tags: ["天台", "黄昏", "青春"],
    synopsis: "写字楼天台是唯一不打卡的地方。四个不同部门的年轻人，在这里分享外卖、抱怨上司，也分享那些不敢在会议室里说出口的野心。",
  },
  {
    id: "bangkok-heatwave", title: "曼谷热浪", category: "urban", region: "泰国", year: 2024, cover: "moonBeach",
    rating: 8.5, views: 138200, episodeCount: 8, director: "颂猜", studio: "曼谷九号", duration: "24 分钟 / 集",
    tags: ["热带", "夜市", "夏夜"],
    synopsis: "泼水节前最热的那个星期，夜市摊主和来自北方的旅人共用一台旧风扇。热浪退去之前，他们决定先不讨论未来。",
  },
  {
    id: "dream-of-long-night", title: "绮梦长夜", category: "classic", region: "日本", year: 2025, cover: "moonGarden",
    rating: 9.1, views: 322800, episodeCount: 12, director: "白川遥", studio: "白川工作室", duration: "27 分钟 / 集",
    tags: ["古装", "和风", "庭院"],
    synopsis: "江户末年的深宅里，一名画师受托为女主人绘制屏风。随着四季流转，画里的庭院越来越满，现实中的庭院却越来越空。",
  },
  {
    id: "spring-palace-chronicle", title: "春宫遗事", category: "classic", region: "中国香港", year: 2024, cover: "crimsonCurtain",
    rating: 8.9, views: 268400, episodeCount: 14, director: "陈立行", studio: "蓝调映像", duration: "29 分钟 / 集",
    tags: ["宫廷", "权谋", "古典"],
    synopsis: "新帝登基那年，宫中一幅失传的绢本画卷重现。画卷上画着先帝的秘密，也画着三个家族三十年不敢碰的旧账。",
  },
  {
    id: "courtesan-tale", title: "花魁物语", category: "classic", region: "日本", year: 2026, cover: "silkDrape",
    rating: 9.3, views: 401500, episodeCount: 13, director: "高桥凉", studio: "夜色制作", duration: "28 分钟 / 集",
    tags: ["花街", "和服", "命运"],
    synopsis: "吉原最负盛名的花魁，在赎身的前一夜收到一封没有署名的信。信里只有一句话：明天不要走出那扇门。",
  },
  {
    id: "deep-palace-grudge", title: "深宫怨", category: "classic", region: "韩国", year: 2023, cover: "vintageMirror",
    rating: 8.7, views: 194700, episodeCount: 11, director: "朴承宇", studio: "首尔光映", duration: "27 分钟 / 集",
    tags: ["宫闱", "古典韩服", "悲剧"],
    synopsis: "被冷落十年的中殿，在宫宴上第一次主动开口。她要为自己讨回的不是宠爱，而是当年那场大火真正的名字。",
  },
  {
    id: "red-thread", title: "红线", category: "classic", region: "中国台湾", year: 2025, cover: "blackLace",
    rating: 8.8, views: 211900, episodeCount: 10, director: "王翊", studio: "蓝调映像", duration: "26 分钟 / 集",
    tags: ["命定", "姻缘", "东方美学"],
    synopsis: "月老祠的守庙人说，红线断了还能接，只是接上之后，两个人的命会往不同的方向走。她不信，直到那根线真的断在手里。",
  },
  {
    id: "jiangnan-rain", title: "江南烟雨", category: "classic", region: "中国香港", year: 2024, cover: "rainGlass",
    rating: 8.6, views: 183500, episodeCount: 12, director: "陈立行", studio: "蓝调映像", duration: "26 分钟 / 集",
    tags: ["水乡", "民国", "旧梦"],
    synopsis: "民国二十三年的梅雨季，绸缎庄的少东家与来取样的女裁缝在檐下躲雨。一把油纸伞，撑开了两个家族此后二十年的纠葛。",
  },
  {
    id: "generals-banquet", title: "将军的夜宴", category: "classic", region: "韩国", year: 2026, cover: "marbleStairs",
    rating: 9.0, views: 276300, episodeCount: 13, director: "李书妍", studio: "首尔光映", duration: "29 分钟 / 集",
    tags: ["夜宴", "权臣", "古典"],
    synopsis: "凯旋之夜，将军在府中设宴。宾客满座，乐声不断，只有他自己知道，这场夜宴真正的客人，是三年前被他亲手埋葬的那个人。",
  },
  {
    id: "listening-rain-in-corridor", title: "廊下听雨", category: "classic", region: "日本", year: 2025, cover: "moonGarden",
    rating: 8.9, views: 167800, episodeCount: 9, director: "白川遥", studio: "白川工作室", duration: "25 分钟 / 集",
    tags: ["回廊", "雨季", "静物"],
    synopsis: "寺院的回廊很长，雨天尤其长。借住在寺里的女书生与年轻的住持，用整整一个雨季，讨论了一句没能说完的偈语。",
  },
  {
    id: "golden-house-dream", title: "金屋残梦", category: "classic", region: "中国台湾", year: 2023, cover: "goldLight",
    rating: 8.5, views: 142600, episodeCount: 10, director: "王翊", studio: "蓝调映像", duration: "26 分钟 / 集",
    tags: ["宅院", "衰败", "旧时代"],
    synopsis: "金家老宅要被拍卖的前三天，散落各地的五个子女回到宅子里清点遗物。他们最先找到的，是母亲藏起来的一本账。",
  },
  {
    id: "changan-under-moon", title: "月下长安", category: "classic", region: "中国香港", year: 2026, cover: "crimsonCurtain",
    rating: 9.2, views: 356200, episodeCount: 14, director: "陈立行", studio: "蓝调映像", duration: "30 分钟 / 集",
    tags: ["长安", "盛世", "群像"],
    synopsis: "上元灯节的长安城，一夜之间发生了七件事。更夫、乐师、舞姬、书生各执一条线，天亮时才发现，他们牵着的是同一盏灯。",
  },
  {
    id: "fourteen-days-in-the-room", title: "密室十四天", category: "suspense", region: "日本", year: 2025, cover: "windowShadow",
    rating: 9.1, views: 378400, episodeCount: 14, director: "高桥凉", studio: "夜色制作", duration: "28 分钟 / 集",
    tags: ["密室", "推理", "双人戏"],
    synopsis: "两个人醒来时，发现自己被关在一间没有窗户的公寓里。桌上有一份十四天的食物，和一张写着彼此真实姓名的纸条。",
  },
  {
    id: "stranger-in-mirror", title: "镜中陌生人", category: "suspense", region: "韩国", year: 2024, cover: "vintageMirror",
    rating: 8.9, views: 262800, episodeCount: 11, director: "朴承宇", studio: "首尔光映", duration: "27 分钟 / 集",
    tags: ["镜像", "失忆", "心理"],
    synopsis: "车祸之后，她每天早上在镜子里看到的脸都不一样。医生说是记忆紊乱，直到有一天，镜子里的那张脸开口说了话。",
  },
  {
    id: "missing-tenant", title: "失踪的房客", category: "suspense", region: "中国香港", year: 2026, cover: "marbleStairs",
    rating: 9.0, views: 298500, episodeCount: 12, director: "陈立行", studio: "蓝调映像", duration: "28 分钟 / 集",
    tags: ["旧楼", "失踪", "调查"],
    synopsis: "包租婆发现三楼房客已经两周没出门，钥匙打开后，房间里干净得像从没有人住过，只有日历还在一页页往前翻。",
  },
  {
    id: "midnight-call", title: "午夜来电", category: "suspense", region: "泰国", year: 2023, cover: "nightAlley",
    rating: 8.4, views: 128900, episodeCount: 9, director: "颂猜", studio: "曼谷九号", duration: "24 分钟 / 集",
    tags: ["来电", "悬疑", "热带"],
    synopsis: "每晚零点整，她都会接到同一个无声来电。第七天，电话那头终于有人说话，声音和她自己一模一样。",
  },
  {
    id: "her-on-the-tape", title: "录像带里的她", category: "suspense", region: "日本", year: 2025, cover: "retroBar",
    rating: 9.2, views: 315700, episodeCount: 13, director: "白川遥", studio: "白川工作室", duration: "27 分钟 / 集",
    tags: ["录像带", "过去", "解谜"],
    synopsis: "旧货店买来的一盒录像带里，记录着一间和他现在住的完全一样的房间。画面里的女人每天对着镜头说话，日期是二十年后。",
  },
  {
    id: "double-identity", title: "双重身份", category: "suspense", region: "韩国", year: 2026, cover: "smokeGold",
    rating: 9.3, views: 388600, episodeCount: 14, director: "李书妍", studio: "首尔光映", duration: "29 分钟 / 集",
    tags: ["身份", "反转", "都市"],
    synopsis: "白天是银行柜员，夜里是替人解决麻烦的中间人。她原本把两种生活分得很清楚，直到某天的客户名单上出现了自己的名字。",
  },
  {
    id: "silent-villa", title: "寂静的别墅", category: "suspense", region: "中国台湾", year: 2024, cover: "hotelSuite",
    rating: 8.8, views: 205300, episodeCount: 10, director: "王翊", studio: "蓝调映像", duration: "26 分钟 / 集",
    tags: ["别墅", "孤岛", "家族秘密"],
    synopsis: "台风封岛的三天里，别墅里的六个人被困在一起。断电之后，他们才发现，房子里多了一个不该在的脚步声。",
  },
  {
    id: "the-follower", title: "跟踪者", category: "suspense", region: "日本", year: 2025, cover: "tokyoSkyline",
    rating: 8.9, views: 248100, episodeCount: 11, director: "高桥凉", studio: "夜色制作", duration: "26 分钟 / 集",
    tags: ["都市", "跟踪", "心理压迫"],
    synopsis: "她发现每天回家的路上，总有一个影子保持同样的距离。报警之后影子消失了，取而代之的，是家门口每天多出的一束花。",
  },
  {
    id: "deserted-island", title: "无人的岛", category: "suspense", region: "泰国", year: 2026, cover: "moonBeach",
    rating: 8.7, views: 165200, episodeCount: 9, director: "颂猜", studio: "曼谷九号", duration: "25 分钟 / 集",
    tags: ["海岛", "生存", "谜团"],
    synopsis: "六名游客参加无人岛露营，返程的船却没有来。他们在岛上找到一座设施完好的房子，冰箱里放着刚做好的六人份晚餐。",
  },
  {
    id: "the-last-night", title: "最后一夜", category: "suspense", region: "中国香港", year: 2024, cover: "nightTrain",
    rating: 9.1, views: 279400, episodeCount: 12, director: "陈立行", studio: "蓝调映像", duration: "28 分钟 / 集",
    tags: ["一夜", "倒计时", "悬疑"],
    synopsis: "酒店即将拆迁的最后一夜，值夜班的经理接待了五位客人。他们互不相识，却都预约了同一个已经不存在房间号。",
  },
];